import { lowerCase, upperFirst } from 'lodash'
import { RUN_REASON_TEXT } from 'app/components/workflows/runViz'
import { parseJsonField } from './deserialize'
import { CHAIN_NODE_SUFFIX } from './stepChecks'

/** One line for a workflow the engine paused: the stopped step by its canvas name, and why. The
 *  reason comes from the notification, which keeps it even after the workflow is fixed. */
export function pausedNoticeLine(
  workflow: { builderJson?: unknown; pausedNodeId?: string | null } | undefined,
  pause: { workflowStep?: string | null; workflowReason?: string | null },
): string {
  const nodeId = workflow?.pausedNodeId?.replace(CHAIN_NODE_SUFFIX, ``)
  const nodes = parseJsonField<{ nodes?: { id: string; data?: { label?: string } }[] }>(workflow?.builderJson)?.nodes
  const label =
    nodes?.find((node) => node.id === nodeId)?.data?.label ?? upperFirst(lowerCase(pause.workflowStep ?? `a step`))
  const why = RUN_REASON_TEXT[pause.workflowReason?.toLowerCase() ?? ``] ?? `a step can't run`
  return `${label} stopped: ${why}`
}
